import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../utils/axiosAdvanced';
import { distancePeriodsMainwithDates } from '../../utils/datePeriodCalculator';

import { toast } from "react-toastify";

export const loadAssetList = async () => {
    try {
        const apiData = await apiClient.get('/asset_list');
        //console.log("AssetList received", apiData);
        return apiData.data;
    } catch (error) {
        //console.log("Aset list error", error);
        throw new Error('Asset List Load Failed', error);
    }

}

export const assetHydrate = async () => {
    try {
        const apiData = await apiClient.get('/hydrate');
        //console.log("Asset List Hydrate", apiData.data);
        return apiData.data;
    } catch (error) {
        throw new Error('Asset Hydration Failed', error);
    }
}

export const firstLoad = createAsyncThunk(
    'assets/firstLoad',
    async (_, thunkAPI) => {
        //console.log("in Asset Rack first load thunk");
        try {
            const assetList = await loadAssetList();
            const rackData = await assetHydrate();
            //console.log("Hydration rack", rackData);
            return { assetList, rackData };
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);


export const getAddress = createAsyncThunk(
    'assets/getAddress',
    async ({ assetId, lat, lng }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/get_address', { lat, lng });
            //console.log("Address", apiData.data);
            return { assetId, address: apiData.data };
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getKilometersOneAsset = createAsyncThunk(
    'assets/getKilometersOneAsset',
    async ({ assetId }, thunkAPI) => {

        const distParams = {
            asset_id: assetId,
            periods: distancePeriodsMainwithDates(),
        };
        //console.log("API Dist launching", distParams);
        try {
            const apiData = await apiClient.post('/full_kmreport', distParams);
            //console.log("API Dist", apiData.data)
            return { assetId, distances: apiData.data.result };
        } catch (error) {
            //console.log("Distance apie error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);


export const changeOdometer = createAsyncThunk(
    'assets/changeOdometer',
    async ({ assetId, odometer, odoDate }, thunkAPI) => {
        //console.log("API Change Odo launching", assetId, odometer, odoDate);
        const odoParams = {
            asset_id: assetId,
            odometer,
            odo_date: odoDate,
        };
        try {
            const apiData = await apiClient.post('/update_odometer', odoParams);
            if (apiData.data.result === 'OK') {
                toast.success("Odometer updated");
                //thunkAPI.dispatch(firstLoad());
            }
            return { assetId, odometer };
        } catch (error) {
            //console.log("Odo change apie error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const changeIcon = createAsyncThunk(
    'assets/changeIcon',
    async ({ assetId, app_icon }, thunkAPI) => {
        //console.log("API Icon change launching", assetId, app_icon);
        const iconParams = {
            assetId, app_icon
        };

        try {
            const apiData = await apiClient.post('/change_icon', iconParams);
            //console.log("ICon", apiData.data.result);
            if (apiData.data.result === 'OK') {
                toast.success("Icon Changed");
                //thunkAPI.dispatch(firstLoad());
            }
            return { assetId, app_icon };
        } catch (error) {
            //console.log("Icon change apie error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const shareLink = createAsyncThunk(
    'assets/shareLink',
    async ({ assetId, duration }, thunkAPI) => {
        //console.log("API Sharelink launched", assetId, duration);
        const shareLinkparams = {
            assetid: assetId, duration
        };
        try {
            const apiData = await apiClient.post('/create_share_link', shareLinkparams);
            //console.log("Link", apiData.data);
            return { assetId, 'link': apiData.data.result };
        } catch (error) {
            //console.log("Sharelink apie error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const lockUnlock = createAsyncThunk(
    'assets/lockUnlock',
    async ({ asset_id, userphone, usercmd, lockpassword }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/lock_unlock', { asset_id, userphone, usercmd, lockpassword });
            //console.log("Link", apiData.data);
            const data = apiData.data;
            if (data.error) {
                toast.error(data.error);
            }
            if (data.result) {
                toast.success(data.result);
            }
            return 'OK';
        } catch (error) {
            //console.log("Sharelink apie error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);